import { useEffect } from 'react'

import { shortcutFor, type Shortcut } from './shortcuts'
import { useLatest } from './useLatest'

export const useShortcuts = (active: boolean, actions: Record<Shortcut, () => void>) => {
  const latest = useLatest(actions)
  useEffect(() => {
    if (!active) return
    const onKey = (event: KeyboardEvent) => {
      const shortcut = shortcutFor(event)
      if (!shortcut) return
      event.preventDefault()
      latest.current[shortcut]()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [active, latest])
}
